/**
 * Author: Vika Aqordi <aqordivika@yahoo.co.id>
 * Created on: 23-08-2024, Bali, Indonesia
 * Github: https://github.com/aqordeon
 * Copyright: 2024
 *
*/


import { irisLocaleStructure } from '@iris/Composables/useIrisLocaleStructure'

export const aikuLocaleStructure = irisLocaleStructure